import { render, staticRenderFns } from "./ManageCommunity.vue?vue&type=template&id=44fa04f6&scoped=true&"
import script from "./ManageCommunity.vue?vue&type=script&lang=ts&"
export * from "./ManageCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./ManageCommunity.vue?vue&type=style&index=0&id=44fa04f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa04f6",
  null
  
)

export default component.exports